import * as React from "react";
import { infoIcons } from "@vebox/etui-core";
import { DefineEquipmentPageProviderContext } from "../../providers/DefineEquipmentPageProvider";
import { CensusCoolerContext } from "../../providers/CensusCollerProvider";
import { createColumnsList, createDatasource } from "./utils";
import "./styles.scss";
import { EmptyState } from "@vebox/etui-core/EmptyState";
import { InfiniteScrollTable } from "../../components/InfiniteScrollTable";

interface EquipmentToCensusTableProps {
	isRefreshingTable: boolean;
}

export const EquipmentToCensusTable: React.FC<EquipmentToCensusTableProps> = ({
	isRefreshingTable,
}) => {
	const { getEquipmentTableHeadersName, AppTranslations } =
		React.useContext(CensusCoolerContext);
	const {
		equipmentList,
		removeEquipment,
		loadCensusEntriesPage,
		hasNextPage,
		isNextPageLoading,
		isFetching,
		refreshEquipmentList,
	} = React.useContext(DefineEquipmentPageProviderContext);
	const [currentPage, setCurrentPage] = React.useState(0);

	const list = React.useMemo(() => {
		return createDatasource(
			equipmentList ?? [],
			removeEquipment,
			refreshEquipmentList,
		);
	}, [equipmentList, isNextPageLoading]);

	const onLoadNextPage = (): Promise<void> => {
		const newPage = currentPage + 1;
		setCurrentPage(newPage);
		return loadCensusEntriesPage(newPage);
	};

	return (
		<div className={"equipment-list-table-container"}>
			<InfiniteScrollTable
				data={list}
				columns={createColumnsList(getEquipmentTableHeadersName)}
				update={onLoadNextPage}
				hasNextPage={hasNextPage}
				isLoading={isFetching || isRefreshingTable}
				height={"calc(70vh - 130px)"}
				emptyPlaceholder={
					<EmptyState>
						<EmptyState.InfoIcon
							styles={{
								root: {
									color: "var(--empty-indicator-svg-stroke)",
								},
							}}
							glyph={infoIcons.NoContent}
						/>
						<EmptyState.Title color="var(--empty-indicator-title-color)">
							{AppTranslations.massiveActions.censusCooler.noEquipmentToCensus}
						</EmptyState.Title>
					</EmptyState>
				}
			/>
		</div>
	);
};
